import * as _evEmitter2 from "ev-emitter";

var _evEmitter = "default" in _evEmitter2 ? _evEmitter2.default : _evEmitter2;

import * as _getSize2 from "get-size";

var _getSize = "default" in _getSize2 ? _getSize2.default : _getSize2;

import * as _fizzyUiUtils2 from "fizzy-ui-utils";

var _fizzyUiUtils = "default" in _fizzyUiUtils2 ? _fizzyUiUtils2.default : _fizzyUiUtils2;

import _cell from "./cell";
import _slide from "./slide";
import _animate from "./animate";

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

// Flickity main

/* eslint-disable max-params */
(function (window, factory) {
  // universal module definition
  if (exports) {
    // CommonJS
    exports = factory(window, _evEmitter, _getSize, _fizzyUiUtils, _cell, _slide, _animate);
  } else {
    // browser global
    let _Flickity = window.Flickity;
    window.Flickity = factory(window, window.EvEmitter, window.getSize, window.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
  }
})(typeof window != "undefined" ? window : exports, function factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
  /* eslint-enable max-params */
  // vars
  const {
    getComputedStyle,
    console
  } = window;
  let {
    jQuery
  } = window; // -------------------------- Flickity -------------------------- //
  // globally unique identifiers

  let GUID = 0; // internal store of all Flickity intances

  let instances = {};

  function Flickity(element, options) {
    let queryElement = utils.getQueryElement(element);

    if (!queryElement) {
      if (console) console.error(`Bad element for Flickity: ${queryElement || element}`);
      return;
    }

    (this || _global).element = queryElement; // do not initialize twice on same element

    if ((this || _global).element.flickityGUID) {
      let instance = instances[(this || _global).element.flickityGUID];
      if (instance) instance.option(options);
      return instance;
    } // add jQuery


    if (jQuery) {
      (this || _global).$element = jQuery((this || _global).element);
    } // options


    (this || _global).options = { ...(this || _global).constructor.defaults
    };
    this.option(options); // kick things off

    this._create();
  }

  Flickity.defaults = {
    accessibility: true,
    // adaptiveHeight: false,
    cellAlign: "center",
    // cellSelector: undefined,
    // contain: false,
    freeScrollFriction: 0.075,
    // friction when free-scrolling
    friction: 0.28,
    // friction when selecting
    namespaceJQueryEvents: true,
    // initialIndex: 0,
    percentPosition: true,
    resize: true,
    selectedAttraction: 0.025,
    setGallerySize: true // watchCSS: false,
    // wrapAround: false

  }; // hash of methods triggered on _create()

  Flickity.create = {};
  let proto = Flickity.prototype; // inherit EventEmitter

  Object.assign(proto, EvEmitter.prototype);

  proto._create = function () {
    let {
      resize,
      watchCSS,
      rightToLeft
    } = (this || _global).options; // add id for Flickity.data

    let id = (this || _global).guid = ++GUID;
    (this || _global).element.flickityGUID = id; // expando

    instances[id] = this || _global; // associate via id
    // initial properties

    (this || _global).selectedIndex = 0; // how many frames slider has been in same position

    (this || _global).restingFrames = 0; // initial physics properties

    (this || _global).x = 0;
    (this || _global).velocity = 0;
    (this || _global).beginMargin = rightToLeft ? "marginRight" : "marginLeft";
    (this || _global).endMargin = rightToLeft ? "marginLeft" : "marginRight"; // create viewport & slider

    (this || _global).viewport = document.createElement("div");
    (this || _global).viewport.className = "flickity-viewport";

    this._createSlider(); // used for keyboard navigation


    (this || _global).focusableElems = [(this || _global).element];

    if (resize || watchCSS) {
      window.addEventListener("resize", this || _global);
    } // add listeners from on option


    for (let eventName in (this || _global).options.on) {
      let listener = (this || _global).options.on[eventName];
      this.on(eventName, listener);
    }

    for (let method in Flickity.create) {
      Flickity.create[method].call(this || _global);
    }

    if (watchCSS) {
      this.watchCSS();
    } else {
      this.activate();
    }
  };
  /**
   * set options
   * @param {Object} opts - options to extend
   */


  proto.option = function (opts) {
    Object.assign((this || _global).options, opts);
  };

  proto.activate = function () {
    if ((this || _global).isActive) return;
    (this || _global).isActive = true;

    (this || _global).element.classList.add("flickity-enabled");

    if ((this || _global).options.rightToLeft) {
      (this || _global).element.classList.add("flickity-rtl");
    }

    this.getSize(); // move initial cell elements so they can be loaded as cells

    let cellElems = this._filterFindCellElements((this || _global).element.children);

    (this || _global).slider.append(...cellElems);

    (this || _global).viewport.append((this || _global).slider);

    (this || _global).element.append((this || _global).viewport); // get cells from children


    this.reloadCells();

    if ((this || _global).options.accessibility) {
      // allow element to focusable
      (this || _global).element.tabIndex = 0; // listen for key presses

      (this || _global).element.addEventListener("keydown", this || _global);
    }

    this.emitEvent("activate");
    this.selectInitialIndex(); // flag for initial activation, for using initialIndex

    (this || _global).isInitActivated = true; // ready event. #493

    this.dispatchEvent("ready");
  }; // slider positions the cells


  proto._createSlider = function () {
    // slider element does all the positioning
    let slider = document.createElement("div");
    slider.className = "flickity-slider";
    (this || _global).slider = slider;
  };

  proto._filterFindCellElements = function (elems) {
    return utils.filterFindElements(elems, (this || _global).options.cellSelector);
  }; // goes through all children


  proto.reloadCells = function () {
    // collection of item elements
    (this || _global).cells = this._makeCells((this || _global).slider.children);
    this.positionCells();

    this._updateWrapShiftCells();

    this.setGallerySize();
  };
  /**
   * turn elements into Flickity.Cells
   * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
   * @returns {Array} items - collection of new Flickity Cells
   */


  proto._makeCells = function (elems) {
    let cellElems = this._filterFindCellElements(elems); // create new Cells for collection


    return cellElems.map(cellElem => new Cell(cellElem));
  };

  proto.getLastCell = function () {
    return (this || _global).cells[(this || _global).cells.length - 1];
  };

  proto.getLastSlide = function () {
    return (this || _global).slides[(this || _global).slides.length - 1];
  }; // positions all cells


  proto.positionCells = function () {
    // size all cells
    this._sizeCells((this || _global).cells); // position all cells


    this._positionCells(0);
  };
  /**
   * position certain cells
   * @param {Integer} index - which cell to start with
   */


  proto._positionCells = function (index) {
    index = index || 0; // also measure maxCellHeight
    // start 0 if positioning all cells

    (this || _global).maxCellHeight = index ? (this || _global).maxCellHeight || 0 : 0;
    let cellX = 0; // get cellX

    if (index > 0) {
      let startCell = (this || _global).cells[index - 1];
      cellX = startCell.x + startCell.size.outerWidth;
    }

    (this || _global).cells.slice(index).forEach(cell => {
      cell.x = cellX;

      this._renderCellPosition(cell, cellX);

      cellX += cell.size.outerWidth;
      (this || _global).maxCellHeight = Math.max(cell.size.outerHeight, (this || _global).maxCellHeight);
    }); // keep track of cellX for wrap-around


    (this || _global).slideableWidth = cellX; // slides

    this.updateSlides(); // contain slides target

    this._containSlides(); // update slidesWidth


    (this || _global).slidesWidth = (this || _global).cells.length ? this.getLastSlide().target - (this || _global).slides[0].target : 0;
  };

  proto._renderCellPosition = function (cell, x) {
    // render position of cell with in slider
    let sideOffset = (this || _global).options.rightToLeft ? -1 : 1;
    let renderX = x * sideOffset;
    if ((this || _global).options.percentPosition) renderX *= (this || _global).size.innerWidth / cell.size.width;
    let positionValue = this.getPositionValue(renderX);
    cell.element.style.transform = `translateX( ${positionValue} )`;
  };
  /**
   * cell.getSize() on multiple cells
   * @param {Array} cells - cells to size
   */


  proto._sizeCells = function (cells) {
    cells.forEach(cell => cell.getSize());
  }; // --------------------------  -------------------------- //


  proto.updateSlides = function () {
    (this || _global).slides = [];
    if (!(this || _global).cells.length) return;
    let {
      beginMargin,
      endMargin
    } = this || _global;
    let slide = new Slide(beginMargin, endMargin, (this || _global).cellAlign);

    (this || _global).slides.push(slide);

    let canCellFit = this._getCanCellFit();

    (this || _global).cells.forEach((cell, i) => {
      // just add cell if first cell in slide
      if (!slide.cells.length) {
        slide.addCell(cell);
        return;
      }

      let slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);

      if (canCellFit(i, slideWidth)) {
        slide.addCell(cell);
      } else {
        // doesn't fit, new slide
        slide.updateTarget();
        slide = new Slide(beginMargin, endMargin, (this || _global).cellAlign);

        (this || _global).slides.push(slide);

        slide.addCell(cell);
      }
    }); // last slide


    slide.updateTarget(); // update .selectedSlide

    this.updateSelectedSlide();
  };

  proto._getCanCellFit = function () {
    let {
      groupCells
    } = (this || _global).options;
    if (!groupCells) return () => false;

    if (typeof groupCells == "number") {
      // group by number. 3 -> [0,1,2], [3,4,5], ...
      let number = parseInt(groupCells, 10);
      return i => i % number !== 0;
    } // default, group by width of slide


    let percent = 1; // parse '75%

    let percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
    if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
    let groupWidth = ((this || _global).size.innerWidth + 1) * percent;
    return (i, slideWidth) => slideWidth <= groupWidth;
  }; // alias _init for jQuery plugin .flickity()


  proto._init = proto.reposition = function () {
    this.positionCells();
    this.positionSliderAtSelected();
  };

  proto.getSize = function () {
    (this || _global).size = getSize((this || _global).element);
    this.setCellAlign();
    (this || _global).cursorPosition = (this || _global).size.innerWidth * (this || _global).cellAlign;
  };

  let cellAlignShorthands = {
    left: 0,
    center: 0.5,
    right: 1
  };

  proto.setCellAlign = function () {
    let {
      cellAlign,
      rightToLeft
    } = (this || _global).options;
    let shorthand = cellAlignShorthands[cellAlign];
    (this || _global).cellAlign = shorthand !== undefined ? shorthand : cellAlign;
    if (rightToLeft) (this || _global).cellAlign = 1 - (this || _global).cellAlign;
  };

  proto.setGallerySize = function () {
    if (!(this || _global).options.setGallerySize) return;
    let height = (this || _global).options.adaptiveHeight && (this || _global).selectedSlide ? (this || _global).selectedSlide.height : (this || _global).maxCellHeight;
    (this || _global).viewport.style.height = `${height}px`;
  };

  proto._updateWrapShiftCells = function () {
    // update isWrapping
    (this || _global).isWrapping = this.getIsWrapping(); // only for wrap-around

    if (!(this || _global).isWrapping) return; // unshift previous cells

    this._unshiftCells((this || _global).beforeShiftCells);

    this._unshiftCells((this || _global).afterShiftCells); // get before cells
    // initial gap


    let beforeGapX = (this || _global).cursorPosition;
    let lastIndex = (this || _global).cells.length - 1;
    (this || _global).beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1); // get after cells
    // ending gap between last cell and end of gallery viewport

    let afterGapX = (this || _global).size.innerWidth - (this || _global).cursorPosition; // start cloning at first cell, working forwards

    (this || _global).afterShiftCells = this._getGapCells(afterGapX, 0, 1);
  };

  proto.getIsWrapping = function () {
    let {
      wrapAround
    } = (this || _global).options;
    if (!wrapAround || (this || _global).slides.length < 2) return false;
    if (wrapAround !== "fill") return true; // check that slides can fit

    let gapWidth = (this || _global).slideableWidth - (this || _global).size.innerWidth;
    if (gapWidth > (this || _global).size.innerWidth) return true; // gap * 2x big, all good
    // check that content width - shifting cell is bigger than viewport width

    for (let cell of (this || _global).cells) {
      if (cell.size.outerWidth > gapWidth) return false;
    }

    return true;
  };

  proto._getGapCells = function (gapX, cellIndex, increment) {
    // keep adding cells until the cover the initial gap
    let cells = [];

    while (gapX > 0) {
      let cell = (this || _global).cells[cellIndex];
      if (!cell) break;
      cells.push(cell);
      cellIndex += increment;
      gapX -= cell.size.outerWidth;
    }

    return cells;
  }; // ----- contain & wrap ----- //
  // contain cell targets so no excess sliding


  proto._containSlides = function () {
    let isContaining = (this || _global).options.contain && !(this || _global).isWrapping && (this || _global).cells.length;
    if (!isContaining) return;

    let contentWidth = (this || _global).slideableWidth - this.getLastCell().size[(this || _global).endMargin]; // content is less than gallery size


    let isContentSmaller = contentWidth < (this || _global).size.innerWidth;

    if (isContentSmaller) {
      // all cells fit inside gallery
      (this || _global).slides.forEach(slide => {
        slide.target = contentWidth * (this || _global).cellAlign;
      });
    } else {
      // contain to bounds
      let beginBound = (this || _global).cursorPosition + (this || _global).cells[0].size[(this || _global).beginMargin];
      let endBound = contentWidth - (this || _global).size.innerWidth * (1 - (this || _global).cellAlign);

      (this || _global).slides.forEach(slide => {
        slide.target = Math.max(slide.target, beginBound);
        slide.target = Math.min(slide.target, endBound);
      });
    }
  }; // ----- events ----- //

  /**
   * emits events via eventEmitter and jQuery events
   * @param {String} type - name of event
   * @param {Event} event - original event
   * @param {Array} args - extra arguments
   */


  proto.dispatchEvent = function (type, event, args) {
    let emitArgs = event ? [event].concat(args) : args;
    this.emitEvent(type, emitArgs);

    if (jQuery && (this || _global).$element) {
      // default trigger with type if no event
      type += (this || _global).options.namespaceJQueryEvents ? ".flickity" : "";
      let $event = type;

      if (event) {
        // create jQuery event
        let jQEvent = new jQuery.Event(event);
        jQEvent.type = type;
        $event = jQEvent;
      }

      (this || _global).$element.trigger($event, args);
    }
  };

  const unidraggerEvents = ["dragStart", "dragMove", "dragEnd", "pointerDown", "pointerMove", "pointerEnd", "staticClick"];
  let _emitEvent = proto.emitEvent;

  proto.emitEvent = function (eventName, args) {
    if (eventName === "staticClick") {
      // add cellElem and cellIndex args to staticClick
      let clickedCell = this.getParentCell(args[0].target);
      let cellElem = clickedCell && clickedCell.element;

      let cellIndex = clickedCell && (this || _global).cells.indexOf(clickedCell);

      args = args.concat(cellElem, cellIndex);
    } // do regular thing


    _emitEvent.call(this || _global, eventName, args); // duck-punch in jQuery events for Unidragger events


    let isUnidraggerEvent = unidraggerEvents.includes(eventName);
    if (!isUnidraggerEvent || !jQuery || !(this || _global).$element) return;
    eventName += (this || _global).options.namespaceJQueryEvents ? ".flickity" : "";
    let event = args.shift(0);
    let jQEvent = new jQuery.Event(event);
    jQEvent.type = eventName;

    (this || _global).$element.trigger(jQEvent, args);
  }; // -------------------------- select -------------------------- //

  /**
   * @param {Integer} index - index of the slide
   * @param {Boolean} isWrap - will wrap-around to last/first if at the end
   * @param {Boolean} isInstant - will immediately set position at selected cell
   */


  proto.select = function (index, isWrap, isInstant) {
    if (!(this || _global).isActive) return;
    index = parseInt(index, 10);

    this._wrapSelect(index);

    if ((this || _global).isWrapping || isWrap) {
      index = utils.modulo(index, (this || _global).slides.length);
    } // bail if invalid index


    if (!(this || _global).slides[index]) return;
    let prevIndex = (this || _global).selectedIndex;
    (this || _global).selectedIndex = index;
    this.updateSelectedSlide();

    if (isInstant) {
      this.positionSliderAtSelected();
    } else {
      this.startAnimation();
    }

    if ((this || _global).options.adaptiveHeight) {
      this.setGallerySize();
    } // events


    this.dispatchEvent("select", null, [index]); // change event if new index

    if (index !== prevIndex) {
      this.dispatchEvent("change", null, [index]);
    }
  }; // wraps position for wrapAround, to move to closest slide. #113


  proto._wrapSelect = function (index) {
    if (!(this || _global).isWrapping) return;
    const {
      selectedIndex,
      slideableWidth,
      slides: {
        length
      }
    } = this || _global; // shift index for wrap, do not wrap dragSelect

    if (!(this || _global).isDragSelect) {
      let wrapIndex = utils.modulo(index, length); // go to shortest

      let delta = Math.abs(wrapIndex - selectedIndex);
      let backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
      let forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);

      if (backWrapDelta < delta) {
        index += length;
      } else if (forewardWrapDelta < delta) {
        index -= length;
      }
    } // wrap position so slider is within normal area


    if (index < 0) {
      (this || _global).x -= slideableWidth;
    } else if (index >= length) {
      (this || _global).x += slideableWidth;
    }
  };

  proto.previous = function (isWrap, isInstant) {
    this.select((this || _global).selectedIndex - 1, isWrap, isInstant);
  };

  proto.next = function (isWrap, isInstant) {
    this.select((this || _global).selectedIndex + 1, isWrap, isInstant);
  };

  proto.updateSelectedSlide = function () {
    let slide = (this || _global).slides[(this || _global).selectedIndex]; // selectedIndex could be outside of slides, if triggered before resize()

    if (!slide) return; // unselect previous selected slide

    this.unselectSelectedSlide(); // update new selected slide

    (this || _global).selectedSlide = slide;
    slide.select();
    (this || _global).selectedCells = slide.cells;
    (this || _global).selectedElements = slide.getCellElements(); // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility

    (this || _global).selectedCell = slide.cells[0];
    (this || _global).selectedElement = (this || _global).selectedElements[0];
  };

  proto.unselectSelectedSlide = function () {
    if ((this || _global).selectedSlide) (this || _global).selectedSlide.unselect();
  };

  proto.selectInitialIndex = function () {
    let initialIndex = (this || _global).options.initialIndex; // already activated, select previous selectedIndex

    if ((this || _global).isInitActivated) {
      this.select((this || _global).selectedIndex, false, true);
      return;
    } // select with selector string


    if (initialIndex && typeof initialIndex == "string") {
      let cell = this.queryCell(initialIndex);

      if (cell) {
        this.selectCell(initialIndex, false, true);
        return;
      }
    }

    let index = 0; // select with number

    if (initialIndex && (this || _global).slides[initialIndex]) {
      index = initialIndex;
    } // select instantly


    this.select(index, false, true);
  };
  /**
   * select slide from number or cell element
   * @param {[Element, Number]} value - zero-based index or element to select
   * @param {Boolean} isWrap - enables wrapping around for extra index
   * @param {Boolean} isInstant - disables slide animation
   */


  proto.selectCell = function (value, isWrap, isInstant) {
    // get cell
    let cell = this.queryCell(value);
    if (!cell) return;
    let index = this.getCellSlideIndex(cell);
    this.select(index, isWrap, isInstant);
  };

  proto.getCellSlideIndex = function (cell) {
    // get index of slide that has cell
    let cellSlide = (this || _global).slides.find(slide => slide.cells.includes(cell));

    return (this || _global).slides.indexOf(cellSlide);
  }; // -------------------------- get cells -------------------------- //

  /**
   * get Flickity.Cell, given an Element
   * @param {Element} elem - matching cell element
   * @returns {Flickity.Cell} cell - matching cell
   */


  proto.getCell = function (elem) {
    // loop through cells to get the one that matches
    for (let cell of (this || _global).cells) {
      if (cell.element === elem) return cell;
    }
  };
  /**
   * get collection of Flickity.Cells, given Elements
   * @param {[Element, Array, NodeList]} elems - multiple elements
   * @returns {Array} cells - Flickity.Cells
   */


  proto.getCells = function (elems) {
    elems = utils.makeArray(elems);
    return elems.map(elem => this.getCell(elem)).filter(Boolean);
  };
  /**
   * get cell elements
   * @returns {Array} cellElems
   */


  proto.getCellElements = function () {
    return (this || _global).cells.map(cell => cell.element);
  };
  /**
   * get parent cell from an element
   * @param {Element} elem - child element
   * @returns {Flickit.Cell} cell - parent cell
   */


  proto.getParentCell = function (elem) {
    // first check if elem is cell
    let cell = this.getCell(elem);
    if (cell) return cell; // try to get parent cell elem

    let closest = elem.closest(".flickity-slider > *");
    return this.getCell(closest);
  };
  /**
   * get cells adjacent to a slide
   * @param {Integer} adjCount - number of adjacent slides
   * @param {Integer} index - index of slide to start
   * @returns {Array} cells - array of Flickity.Cells
   */


  proto.getAdjacentCellElements = function (adjCount, index) {
    if (!adjCount) return (this || _global).selectedSlide.getCellElements();
    index = index === undefined ? (this || _global).selectedIndex : index;
    let len = (this || _global).slides.length;

    if (1 + adjCount * 2 >= len) {
      return this.getCellElements(); // get all
    }

    let cellElems = [];

    for (let i = index - adjCount; i <= index + adjCount; i++) {
      let slideIndex = (this || _global).isWrapping ? utils.modulo(i, len) : i;
      let slide = (this || _global).slides[slideIndex];

      if (slide) {
        cellElems = cellElems.concat(slide.getCellElements());
      }
    }

    return cellElems;
  };
  /**
   * select slide from number or cell element
   * @param {[Element, String, Number]} selector - element, selector string, or index
   * @returns {Flickity.Cell} - matching cell
   */


  proto.queryCell = function (selector) {
    if (typeof selector == "number") {
      // use number as index
      return (this || _global).cells[selector];
    } // do not select invalid selectors from hash: #123, #/. #791


    let isSelectorString = typeof selector == "string" && !selector.match(/^[#.]?[\d/]/);

    if (isSelectorString) {
      // use string as selector, get element
      selector = (this || _global).element.querySelector(selector);
    } // get cell from element


    return this.getCell(selector);
  }; // -------------------------- events -------------------------- //


  proto.uiChange = function () {
    this.emitEvent("uiChange");
  }; // ----- resize ----- //


  proto.onresize = function () {
    this.watchCSS();
    this.resize();
  };

  utils.debounceMethod(Flickity, "onresize", 150);

  proto.resize = function () {
    // #1177 disable resize behavior when animating or dragging for iOS 15
    if (!(this || _global).isActive || (this || _global).isAnimating || (this || _global).isDragging) return;
    this.getSize(); // wrap values

    if ((this || _global).isWrapping) {
      (this || _global).x = utils.modulo((this || _global).x, (this || _global).slideableWidth);
    }

    this.positionCells();

    this._updateWrapShiftCells();

    this.setGallerySize();
    this.emitEvent("resize"); // update selected index for group slides, instant
    // TODO: position can be lost between groups of various numbers

    let selectedElement = (this || _global).selectedElements && (this || _global).selectedElements[0];
    this.selectCell(selectedElement, false, true);
  }; // watches the :after property, activates/deactivates


  proto.watchCSS = function () {
    if (!(this || _global).options.watchCSS) return;
    let afterContent = getComputedStyle((this || _global).element, ":after").content; // activate if :after { content: 'flickity' }

    if (afterContent.includes("flickity")) {
      this.activate();
    } else {
      this.deactivate();
    }
  }; // ----- keydown ----- //
  // go previous/next if left/right keys pressed


  proto.onkeydown = function (event) {
    let {
      activeElement
    } = document;
    let handler = Flickity.keyboardHandlers[event.key]; // only work if element is in focus

    if (!(this || _global).options.accessibility || !activeElement || !handler) return;

    let isFocused = (this || _global).focusableElems.some(elem => activeElement === elem);

    if (isFocused) handler.call(this || _global);
  };

  Flickity.keyboardHandlers = {
    ArrowLeft: function () {
      this.uiChange();
      let leftMethod = (this || _global).options.rightToLeft ? "next" : "previous";
      this[leftMethod]();
    },
    ArrowRight: function () {
      this.uiChange();
      let rightMethod = (this || _global).options.rightToLeft ? "previous" : "next";
      this[rightMethod]();
    }
  }; // ----- focus ----- //

  proto.focus = function () {
    (this || _global).element.focus({
      preventScroll: true
    });
  }; // -------------------------- destroy -------------------------- //
  // deactivate all Flickity functionality, but keep stuff available


  proto.deactivate = function () {
    if (!(this || _global).isActive) return;

    (this || _global).element.classList.remove("flickity-enabled");

    (this || _global).element.classList.remove("flickity-rtl");

    this.unselectSelectedSlide(); // destroy cells

    (this || _global).cells.forEach(cell => cell.destroy());

    (this || _global).viewport.remove(); // move child elements back into element


    (this || _global).element.append(...(this || _global).slider.children);

    if ((this || _global).options.accessibility) {
      (this || _global).element.removeAttribute("tabIndex");

      (this || _global).element.removeEventListener("keydown", this || _global);
    } // set flags


    (this || _global).isActive = false;
    this.emitEvent("deactivate");
  };

  proto.destroy = function () {
    this.deactivate();
    window.removeEventListener("resize", this || _global);
    this.allOff();
    this.emitEvent("destroy");

    if (jQuery && (this || _global).$element) {
      jQuery.removeData((this || _global).element, "flickity");
    }

    delete (this || _global).element.flickityGUID;
    delete instances[(this || _global).guid];
  }; // -------------------------- prototype -------------------------- //


  Object.assign(proto, animatePrototype); // -------------------------- extras -------------------------- //

  /**
   * get Flickity instance from element
   * @param {[Element, String]} elem - element or selector string
   * @returns {Flickity} - Flickity instance
   */

  Flickity.data = function (elem) {
    elem = utils.getQueryElement(elem);
    if (elem) return instances[elem.flickityGUID];
  };

  utils.htmlInit(Flickity, "flickity");
  let {
    jQueryBridget
  } = window;

  if (jQuery && jQueryBridget) {
    jQueryBridget("flickity", Flickity, jQuery);
  } // set internal jQuery, for Webpack + jQuery v3, #478


  Flickity.setJQuery = function (jq) {
    jQuery = jq;
  };

  Flickity.Cell = Cell;
  Flickity.Slide = Slide;
  return Flickity;
});

export default exports;